<template>
    <div v-loading="loadingContent">
        <div class="esocial-config-header">
          <div class="esocial-config-header__icon">
            <i class="fa fa-cogs" aria-hidden="true"></i>
          </div>
          <div>
            <h2 class="esocial-config-header__title">Configurações do eSocial</h2>
            <p class="esocial-config-header__subtitle">
              Defina se e quando os lotes de eventos são gerados e enviados automaticamente para o eSocial.
            </p>
          </div>
        </div>

        <div class="esocial-config-card">
          <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
            <div slot="form-footer"></div>
          </ed-form>

          <ed-alert
            v-if="lastUpdate.usuario"
            class="mt-1"
            type="success"
            title="Última Atualização"
            :description="lastUpdate.usuario.usuario + ' em ' + toDate(lastUpdate.updated_at)"
          />
        </div>
    </div>
</template>

<script>

    import Rest from 'common/rest'
    import EdForm from 'common/form'
    import { EdAlert } from 'template'
    import FormItems from './_form/configuracao'

    export default {
        name:"esocial-configuracao",
        mixins:[Rest],
        components:{EdForm, EdAlert},
      	watch: {
          'formData.ativo'(){
            this.config.disabled.empresas = (this.formData.ativo == 0);
            this.config.disabled.data_inicio = (this.formData.ativo == 0);
            this.config.disabled.empresas_processar = (this.formData.ativo == 0);
          }
        },
        data () {
          return {
            response:{},
            config:{
              click:{
                empresas:this.getEmpresa,
                empresas_processar:this.getEmpresa,
                save:this.salvar
              },
              list:{
                empresas:[],
                empresas_processar:[]
              },
              loading:{
                empresas:false,
                empresas_processar:false,
                save:false
              },
              disabled:{
                empresas:true,
                empresas_processar:true,
                data_inicio:true
              }
            },
            formData:{
              id:0,
              ativo:0,
              empresas:[],
              data_inicio:this.toDate(),
            },
            lastUpdate:{
              usuario:null,
              updated_at:null,
            },
            formItems:[],
            loadingContent:true,
          }
        },

        created(){
        },

        mounted() {
          this.getEsocialConfiguracao();
          //this.getEmpresa();

          this.formItems = FormItems;
        },

        methods:{

            getEmpresa: function(_search,_empresas){

              this.config.loading.empresas = true;
              this.config.loading.empresas_processar = true;
              this.config.list.empresas = [];
              this.config.list.empresas_processar = [];

                this.get('/empresa',{search:_search,pagination:10,filter:{empresas:_empresas}}).then((result)=>{

                  result = result[0];
                  this.config.loading.empresas = false;
                  this.config.loading.empresas_processar = false

                  if(result.status == 200){
                    this.config.list.empresas  = result.data.data;
                    this.config.list.empresas_processar  = result.data.data;
                  }
                });

            },

            getEsocialConfiguracao(){

              this.get('/esocial/configuracao').then((result)=>{

                result = result[0];

                this.loadingContent = false;
                this.config.list.empresas = [];
                this.config.list.empresas_processar = [];

                if(result.status == 200 && result.data){
                  this.formData = {
                    id: result.data.id,
                    ativo: result.data.ativo,
                    empresas:[],
                    empresas_processar:[],
                    data_inicio:(result.data.data_inicio ? this.toDate(result.data.data_inicio,true) : null),
                  }

                  this.lastUpdate = {
                    usuario:result.data.usuario,
                    updated_at:result.data.updated_at,
                  }

                  for (let i = 0; i < result.data.empresas.length; i++) {
                    const element = result.data.empresas[i];

                    this.formData.empresas.push(element.id);
                    this.config.list.empresas.push(element);
                  }

                  
                  for (let i = 0; i < result.data.empresas_processar.length; i++) {
                    const element = result.data.empresas_processar[i];

                    this.formData.empresas_processar.push(element.id);
                    this.config.list.empresas_processar.push(element);
                  }
                }
              });
            },

            salvar(formName){

              this.config.loading.save = true;
              this.response = {};

              this.post('esocial/configuracao/editar',this.formData,false).then((result)=>{

                this.config.loading.save = false;

                result = result[0];

                this.response = result;

                if(result.status == 200){
                  this.edMsg('Dados atualizados com sucesso');
                  this.getEsocialConfiguracao();
                }
              });

            }

        }
    }
</script>

<style lang="scss" scoped>
.esocial-config-header {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  margin-bottom: 18px;
}

.esocial-config-header__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 10px;
  background: rgba(168, 121, 31, 0.12);
  color: rgb(168, 121, 31);
  font-size: 17px;
}

.esocial-config-header__title {
  margin: 0 0 2px;
  font-size: 16px;
  font-weight: 700;
  color: #1f2329;
}

.esocial-config-header__subtitle {
  margin: 0;
  font-size: 12.5px;
  color: #6b7280;
  line-height: 1.5;
  max-width: 640px;
}

.esocial-config-card {
  background: #fff;
  border: 1px solid #eef0f2;
  border-radius: 10px;
  padding: 22px 24px 26px;
}
</style>



// WEBPACK FOOTER //
// index.vue?4724fe0f